module.exports = __webpack_public_path__ + "media/images/edit-cbece7f8607a2f513d5bfb1507569d6b.svg";